import { Directive, ElementRef, OnInit, Renderer2, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';


@Directive({
    selector: '[appRole]',
    standalone: true,
})
export class RoleDirective implements OnInit {
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private authService = inject(AuthService);

  readonly appRole = input<string[]>(undefined);


  ngOnInit(): void {

    const appRole = this.appRole();
    if(!appRole || appRole.length === 0)
      return;

    const userRole = this.authService.hasRoles(appRole);

    if(!userRole) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
    }
  }
}
